<script lang="ts">
  import { Badge, Button, Card, CardHeader, Col, Row } from "sveltestrap";
  import UpcomingCourses from "./UpcomingCourses.svelte";
  import { KnowledgeCategories, Knowledgefilter, href } from "../../../../utils/Constant/Constant";
  import {knowledgeCategorie} from "../../../../Data/Miscellaneous/KnowledgeBase"
  import Link from "svelte-link";
  let open:boolean = true
  let classAdd:boolean = false
  function hanldeFilter (){
    classAdd = !classAdd
  }
</script>
<Col xl="3" class="xl-40">
    <div class="job-sidebar">
        <Button color="primary" class="job-toggle" href={href} on:click={hanldeFilter}>{Knowledgefilter}</Button>
        <div class="job-left-aside custom-scrollbar custom-scrollbar {classAdd ? "open" : ""}">
            <div class="default-according style-1 faq-accordion job-accordion" id="accordionoc">
            <Row>
                <Col xl="12">
                    <Card>
                        <CardHeader>
                            <h5 class="mb-0 p-0">
                                <Button class="btn-link" on:click={()=>open = !open}>{KnowledgeCategories}</Button>
                            </h5>
                        </CardHeader>
                        <div class="collapse {open ? "show" : ""}" >
                            {#each knowledgeCategorie as categoriesItem}
                                <div class="categories">
                                    <div class="learning-header">
                                        <span class="f-w-600">{categoriesItem.title}</span>
                                    </div>
                                    <ul>
                                    {#each categoriesItem.subdata as data}
                                        <li>
                                            <Link href={href}>{data.header} </Link>
                                            <Badge color="primary" class="pull-right">{data.badge}</Badge>
                                        </li>
                                    {/each}
                                    </ul>
                                </div>
                            {/each}
                        </div>
                    </Card>
                </Col>
                <UpcomingCourses />
            </Row>
            </div>
        </div>
    </div>
</Col>